import React from "react";

export default function RecentEvents() {
  return (
    <div id="recentevents" className="w-full lg:mt-10 py-24 flex justify-center flex-col items-center text-sky-800 dark:text-sky-500">
      <div className="flex flex-col items-center w-11/12 md:w-10/12">
        <div className="flex justify-start w-full flex-col ">
          <h1 className="text-3xl font-bold flex justify-start ">
            Explore our recent events
          </h1>
          <div className="grid lg:grid-cols-3  w-full mt-16 gap-8 ">
            {/* 1st card */}

            <a className="dark:bg-content bg-center bg-cover hover:shadow-2xl dark:hover:shadow-gray-600 px-7 py-11 rounded-lg bg-gray-100 dark:bg-transparent cursor-pointer custom_shadow" href="https://gdsc.community.dev/events/details/developer-student-clubs-usman-institute-of-technology-presents-cloud-study-jam/" target="__blank"><div >
              <img
                src="
            /img/cloud.jpeg"
                alt=""
                className="rounded-lg"
              />
              <h1 className="text-2xl font-bold mt-20">
              Cloud Study Jam
              </h1>
              <p className="mt-2 text-gray-500 dark:text-gray-400">
              Students were given 30 Day free access to Qwiklabs to learn Google Cloud technologies, Google Cloud technology skill Badges and Swags (if you complete the minimum 12 labs by the deadline) will be provided
              </p>
            </div>
            </a>
            {/* 2nd card */}
            <a className="dark:bg-content bg-center bg-cover hover:shadow-2xl dark:hover:shadow-gray-600 px-7 py-11 rounded-lg bg-gray-100 dark:bg-transparent cursor-pointer custom_shadow" href="#" target="__blank">
            <div>
              <h1 className="text-2xl font-bold mt-0">
                Web 3.0 workshop
              </h1>
              <p className="mt-2 text-gray-500 dark:text-gray-400">
               Hands on workshop by Expedite Desgin to provide web3 knowldege to students
              </p>
              <img
                src="
            /img/web3.jpg"
                alt=""
                className="mt-20 rounded-lg"
              />
            </div>
            </a>
            {/* //3rd */}
            <a className="dark:bg-content bg-center bg-cover hover:shadow-2xl dark:hover:shadow-gray-600 px-7 py-11 rounded-lg bg-gray-100 dark:bg-transparent cursor-pointer custom_shadow" href="https://gdsc.community.dev/events/details/developer-student-clubs-usman-institute-of-technology-presents-grand-launch-of-google-developer-student-clubs-uitu-chapter-closed-1/" target="__blank">
            <div>
              <img
                src="
            /img/launchevent.png"
                alt=""
                className="rounded-lg"
              />
              <h1 className="text-2xl font-bold mt-20">
                GDSC UIT Launch event
              </h1>
              <p className="mt-2 text-gray-500 dark:text-gray-400">
                GDSC UIT launch event in which our current lead Syed Hamza Hoda, ex lead Raheel Siddique and provost Shoaib Zaidi shared their experience
              </p>
            </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
